<template>
  <div>
    <div class="searchBox" ref="searchBox" style="display: inline;">
      <el-form
        :inline="true"
        class="demo-form-inline"
        label-width="110px"
        size="mini"
      >
        <div class="searchBox inpBox">
          <div class="item">
            <el-form-item label="客户名称:" prop="nameLike">
              <el-input placeholder="" v-model="searchFrom.nameLike"></el-input>
            </el-form-item>
            <!-- <el-form-item label="租户名称:" prop="twoCustomerTaxId">
               <el-input  placeholder="" v-model="searchFrom.tenantName"></el-input>
            </el-form-item> -->
            <el-form-item label="客户等级:" prop="customerGradeId">
              <el-select
                v-model="searchFrom.customerGradeId"
                placeholder="请选择客户等级"
              >
                <el-option
                  v-for="item in gradeList"
                  :key="item.id"
                  :label="item.gradeName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否开通租户:" prop="openTenantFlag">
              <el-select
                v-model="searchFrom.openTenantFlag"
                placeholder="请选择"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="经营业务:" prop="businessId">
              <el-cascader
                v-model="searchFrom.businessId"
                :options="yewuTree"
                :show-all-levels="false"
                :props="{
                  expandTrigger: 'hover',
                  label: 'name',
                  value: 'id',
                  emitPath: false,
                }"
              ></el-cascader>
            </el-form-item>
            <el-form-item
              label="统一社会信用代码:"
              label-width="130px"
              prop="taxpayerNumber"
            >
              <el-input
                placeholder=""
                v-model="searchFrom.taxpayerNumber"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="searchBtnBox" style="margin-top: 10px; margin-bottom: 10px">
          <div class="searchBtnBox-left">
            <el-form-item>
              <el-button type="primary" @click="searchFn">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="resetForm('searchFrom')"
                >重置</el-button
              >
            </el-form-item>
          </div>
          <div class="searchBtnBox-right">
            <el-form-item>
              <el-button
                type="primary"
                v-if="ZtenantCode || btnFlg[0]"
                @click="addFn"
                >添加</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                v-if="ZtenantCode || btnFlg[1]"
                @click="exportFn"
                :disabled="isDisable"
                >导出</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                v-if="ZtenantCode || btnFlg[2]"
                @click="importFn"
                >导入</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                v-if="ZtenantCode || btnFlg[2]"
                @click="modelDown"
                >模板下载</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="customerGrade"
                >客户等级</el-button
              >
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table
        :data="tableList"
        ref="table"
        v-loading="loading"
        bordersize="mini"
        @selection-change="selectGoods"
        @row-click="handleRowClick"
        style="width: 100%"
        height="100%"
        center
        border
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column
          type="index"
          prop="date"
          width="55"
          label="序号"
        ></el-table-column>
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <div>
              <el-button
                type="text"
                size="mini"
                v-if="ZtenantCode || btnFlg[3]"
                @click="editFn(scope.row)"
                >修改</el-button
              >
              <el-button
                type="text"
                size="mini"
                v-if="ZtenantCode || btnFlg[4]"
                @click="detailFn(scope.row)"
                >详情</el-button
              >
              <el-button
                type="text"
                size="mini"
                v-if="
                  scope.row.openTenantFlag != 1 && (ZtenantCode || btnFlg[5])
                "
                @click="delFn(scope.row)"
                >删除</el-button
              >
              <el-button
                type="text"
                size="mini"
                v-if="ZtenantCode || btnFlg[6]"
                @click="zuhuFn(scope.row)"
                >关联租户</el-button
              >
              <el-button
                type="text"
                size="mini"
                v-if="ZtenantCode || btnFlg[7]"
                @click="gexinghuaFn(scope.row)"
                >个性化配置</el-button
              >
              <el-button
                type="text"
                size="mini"
                v-if="
                  scope.row.openTenantFlag == 1 && (ZtenantCode || btnFlg[8])
                "
                @click="weihuFn(scope.row)"
                >维护</el-button
              >
              <el-button
                type="text"
                size="mini"
                v-if="
                  scope.row.openTenantFlag != 1 &&
                    scope.row.classify == 1 &&
                    (isPingtai || scope.row.openFlags.indexOf('1') != -1) &&
                    (ZtenantCode || btnFlg[9])
                "
                @click="kaitongFn(scope.row)"
                >开通</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          width="260"
          :formatter="emptyFn"
          :show-overflow-tooltip="true"
          label="客户名称"
        ></el-table-column>
        <el-table-column
          prop="authStatus"
          :formatter="emptyFn"
          :show-overflow-tooltip="true"
          label="认证状态"
        >
          <template slot-scope="scope">
            <span :class="[`authStatus_${scope.row.authStatus}`]">
              {{ authStatusDic[scope.row.authStatus] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="customerGradeName"
          width="120"
          :formatter="emptyFn"
          :show-overflow-tooltip="true"
          label="客户等级"
        ></el-table-column>
        <el-table-column
          prop="sealManger"
          width="120"
          :formatter="emptyFn"
          :show-overflow-tooltip="true"
          label="印章管理员"
        ></el-table-column>
        <el-table-column
          prop="sealMangerMobile"
          width="120"
          :formatter="emptyFn"
          :show-overflow-tooltip="true"
          label="印章管理员电话"
        ></el-table-column>
        <el-table-column
          prop="sealMangerIdNumber"
          width="180"
          :formatter="emptyFn"
          :show-overflow-tooltip="true"
          label="印章管理员身份证号码"
        ></el-table-column>
        <el-table-column
          prop="sealAuthStatus"
          width="180"
          :formatter="emptyFn"
          :show-overflow-tooltip="true"
          label="授权状态"
        >
          <template slot-scope="scope">
            <span :class="[`sealAuthStatus_${scope.row.sealAuthStatus}`]">
              {{ sealAuthStatusDic[scope.row.sealAuthStatus] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="sealAuthStatusEndTime"
          width="180"
          :formatter="emptyFn"
          :show-overflow-tooltip="true"
          label="授权截至日期"
        ></el-table-column>
        <el-table-column
          prop=""
          width="180"
          :formatter="emptyFn"
          :show-overflow-tooltip="true"
          label="授权记录"
        >
          <template slot-scope="scope">
            <div>
              <el-button
                type="text"
                size="mini"
                btnCode="00IP001B006"
                @click="lookAR(scope)"
                >查看</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="businessName"
          min-width="200"
          :formatter="emptyFn"
          label="经营业务"
        ></el-table-column>
        <el-table-column property="classify" label="客户类型" min-width="100">
          <template scope="scope">
            <div>
              {{ ['正式', '个体', '临时'][scope.row.classify - 1] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          property="openTenantFlag"
          label="开通租户"
          min-width="100"
        >
          <template scope="scope">
            <div>
              {{ ['否', '是'][scope.row.openTenantFlag] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="taxpayerNumber"
          width="200"
          :formatter="emptyFn"
          label="统一社会信用代码"
        ></el-table-column>
        <el-table-column
          prop="natureName"
          :show-overflow-tooltip="true"
          width="200"
          :formatter="emptyFn"
          label="机构性质"
        ></el-table-column>
        <el-table-column
          prop="legalPerson"
          :show-overflow-tooltip="true"
          width="120"
          :formatter="emptyFn"
          label="法人姓名"
        ></el-table-column>
        <el-table-column
          prop="contactsName"
          :show-overflow-tooltip="true"
          width="120"
          :formatter="emptyFn"
          label="联系人"
        ></el-table-column>
        <el-table-column
          prop="contactsMoblie"
          width="120"
          :formatter="emptyFn"
          label="联系电话"
        ></el-table-column>
        <el-table-column
          prop="createUserName"
          :formatter="emptyFn"
          label="创建人"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          width="170"
          :formatter="dateTimeFormat"
          label="创建时间"
        ></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50, 100, 200, 1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog
      :title="title"
      :close-on-click-modal="true"
      :close-on-press-escape="false"
      class="jiaoyan"
      @close="closeDialog"
      :visible.sync="dialogVisible"
      width="1100px"
      center

    >
      <span>
        <el-form
          :inline="true"
          :rules="rules"
          :model="addFrom"
          ref="addFrom"
          class="demo-form-inline"
          label-width="140px"
          size="mini"
        >
          <div class="inpBox">
            <div style="display: flex; justify-content: space-between;">
              <el-form-item label="客户名称:" prop="name">
                <el-input
                  placeholder=""
                  maxlength="30"
                  v-model.trim="addFrom.name"
                  v-if="!detailData.name"
                  @blur="nameBlur"
                ></el-input>
                <div v-else>{{ detailData.name }}</div>
              </el-form-item>
              <el-form-item label="客户类型:" prop="classify">
                <el-select
                  v-model="addFrom.classify"
                  placeholder="请选择"
                  v-if="!detailData.classify"
                  @change="classifyChange"
                >
                  <el-option label="正式" :value="1"></el-option>
                  <el-option label="临时" :value="3"></el-option>
                </el-select>
                <div v-else style="wdith: 150px">
                  {{ ['正式', '个体', '临时'][detailData.classify - 1] }}
                </div>
              </el-form-item>
              <el-form-item
                label="统一社会信用代码:"
                prop="taxpayerNumber"
                label-width="150px"
                v-if="addFrom.classify == 1"
              >
                <el-input
                  placeholder=""
                  maxlength="20"
                  v-model.trim="addFrom.taxpayerNumber"
                  v-if="!detailData.taxpayerNumber"
                ></el-input>
                <div v-else>{{ detailData.taxpayerNumber }}</div>
              </el-form-item>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <el-form-item label="客户等级:" prop="customerGradeId">
                <el-select
                  placeholder="请选择"
                  value-key="id"
                  v-model="addFrom.customerGradeId"
                  filterable
                >
                  <el-option
                    v-for="item in gradeList"
                    :key="item.id"
                    :label="item.gradeName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="机构性质:" prop="nature">
                <el-select
                  v-model="addFrom.nature"
                  placeholder="请选择"
                  v-if="!detailData.nature"
                  filterable
                >
                  <el-option
                    v-for="val in jigouList"
                    :label="val.showName"
                    :value="val.itemNo"
                    :key="val.itemNo"
                  ></el-option>
                </el-select>
                <div v-else>{{ addFrom.natureName }}</div>
              </el-form-item>
              <el-form-item label="企业类型:" prop="enterpriseType">
                <el-select
                  placeholder="请选择"
                  value-key="id"
                  v-model="addFrom.enterpriseType"
                  filterable
                >
                  <el-option label="一般人" :value="0"></el-option>
                  <el-option label="小规模" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <el-form-item
                label="企业地址:"
                prop="detailAddress"
                class="dizhi"
              >
                <el-input
                  placeholder=""
                  class="disabled"
                  maxlength="300"
                  :readonly="true"
                  v-model="addFrom.detailAddress"
                ></el-input>
                <i
                  class="el-icon-location"
                  @click="dizhiFn"
                  v-if="!detailData.detailAddress"
                ></i>
              </el-form-item>
              <el-form-item label="邮箱地址:" prop="email" v-if="isPingtai">
                <el-input
                  placeholder=""
                  maxlength="30"
                  v-model.trim="addFrom.email"
                ></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="开户行:" prop="openingBank">
                <el-input
                  placeholder=""
                  maxlength="30"
                  v-model.trim="addFrom.openingBank"
                ></el-input>
              </el-form-item>
              <el-form-item label="银行账号:" prop="bankAccount">
                <el-input
                  placeholder=""
                  v-number-input.float="0"
                  maxlength="30"
                  v-model.trim="addFrom.bankAccount"
                ></el-input>
              </el-form-item>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <business
                :addFrom="addFrom"
                :openObjs="isPingtai ? 1 : 2"
                :tishiFlag="!isAdd"
                ref="business"
                v-if="dialogVisible"
              ></business>
            </div>
            <div>
              <el-form-item label="联系人:" prop="contactsName">
                <el-input
                  placeholder=""
                  maxlength="20"
                  v-model.trim="addFrom.contactsName"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="contactsMoblie">
                <el-input
                  placeholder=""
                  v-number-input.float="0"
                  maxlength="11"
                  v-model.trim="addFrom.contactsMoblie"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="联系人身份证号:"
                prop="contactsIdentityCard"
                v-if="!isAdd"
              >
                <el-input
                  placeholder=""
                  maxlength="18"
                  v-model.trim="addFrom.contactsIdentityCard"
                ></el-input>
              </el-form-item>
            </div>
            <div v-if="isPingtai">
              <div>
                <!-- <el-form-item label="企业类型:" prop="enterpriseType">
                  <el-select
                    placeholder="请选择"
                    value-key="id"
                    v-model="addFrom.enterpriseType"
                    filterable
                  >
                    <el-option label="一般人" :value="0"></el-option>
                    <el-option label="小规模" :value="1"></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item label="主管税务机关:" prop="taxCompetent">
                  <el-input
                    maxlength="20"
                    v-model="addFrom.taxCompetent"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="注册资本:"
                  prop="registeredCapital"
                  class="jiage"
                >
                  <el-input
                    maxlength="20"
                    v-number-input.float="2"
                    v-model="addFrom.registeredCapital"
                  ></el-input
                  ><span class="danwei">万元</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="经营范围:" prop="businessScope">
                  <el-input
                    placeholder=""
                    type="textarea"
                    :rows="3"
                    style="width: 800px"
                    maxlength="200"
                    v-model.trim="addFrom.businessScope"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div>
              <el-form-item label="备注信息:" prop="remark">
                <el-input
                  placeholder=""
                  type="textarea"
                  :rows="3"
                  style="width: 800px"
                  maxlength="200"
                  v-model.trim="addFrom.remark"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 开通 -->
    <el-dialog
      title="开通"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="jiaoyan"
      @close="closeDialog"
      :visible.sync="KTDialog"
      width="1100px"
      center
    >
      <span>
        <el-form
          :inline="true"
          :rules="KTrules"
          :model="KTfrom"
          ref="KTfrom"
          class="demo-form-inline"
          label-width="140px"
          size="mini"
        >
          <div class="inpBox">
            <div>
              <business
                :addFrom="KTfrom"
                :openObjs="isPingtai ? 1 : 3"
                ref="business"
                v-if="KTDialog"
              ></business>
            </div>
            <div v-if="!isPingtai">
              <el-form-item label="联系人:" prop="contactsName">
                <div>{{ row.contactsName }}</div>
              </el-form-item>
              <el-form-item label="联系人身份证号:" prop="contactsIdentityCard">
                <el-input
                  placeholder=""
                  maxlength="18"
                  v-model.trim="KTfrom.contactsIdentityCard"
                ></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="法人姓名:" prop="legalPerson">
                <el-input
                  placeholder=""
                  maxlength="20"
                  v-if="!detailData.legalPerson"
                  v-model.trim="KTfrom.legalPerson"
                ></el-input>
                <el-input
                  placeholder=""
                  class="disabled"
                  maxlength="50"
                  v-else
                  :readonly="true"
                  v-model="detailData.legalPerson"
                ></el-input>
              </el-form-item>
              <el-form-item label="法人身份证号:" prop="legalIdentityCard">
                <el-input
                  placeholder=""
                  maxlength="18"
                  v-if="!detailData.legalIdentityCard"
                  v-model.trim="KTfrom.legalIdentityCard"
                ></el-input>
                <el-input
                  placeholder=""
                  class="disabled"
                  maxlength="18"
                  v-else
                  :readonly="true"
                  v-model="detailData.legalIdentityCard"
                ></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item
                label="法人身份证是否长期:"
                prop="legalIsLong"
                class="ziti"
                label-width="160px"
              >
                <template>
                  <div style="width: 180px">
                    <el-radio-group
                      v-model="KTfrom.legalIsLong"
                      v-if="!detailData.legalIsLong"
                    >
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                    <span v-else>{{
                      detailData.legalIsLong == 1 ? '是' : '否'
                    }}</span>
                  </div>
                </template>
              </el-form-item>
              <el-form-item
                label="法人身份证有效期:"
                prop="legalPersonidValidity"
                v-if="KTfrom.legalIsLong == 2"
              >
                <el-date-picker
                  v-if="!detailData.legalPersonidValidity"
                  v-model="KTfrom.legalPersonidValidity"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
                <el-date-picker
                  v-else
                  :disabled="true"
                  v-model="KTfrom.legalPersonidValidity"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
            </div>
            <div v-if="isPingtai">
              <el-form-item label="联系人:" prop="contactsName">
                <el-input
                  placeholder=""
                  maxlength="20"
                  v-model.trim="KTfrom.contactsName"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="contactsMoblie">
                <el-input
                  placeholder=""
                  v-number-input.float="0"
                  maxlength="11"
                  v-model.trim="KTfrom.contactsMoblie"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人身份证号:" prop="contactsIdentityCard">
                <el-input
                  placeholder=""
                  maxlength="18"
                  v-model.trim="KTfrom.contactsIdentityCard"
                ></el-input>
              </el-form-item>
            </div>
            <div class="addressBox">
              <h4 class="title">
                <span
                  ><i class="fa fa-picture-o iconFont" aria-hidden="true"></i
                  >证件信息</span
                >
              </h4>
            </div>
            <div class="box" v-if="KTDialog">
              <div class="imgBox">
                <uploadImgs
                  :imgList.sync="imgYY"
                  v-if="!detailData.bsnsLicensepicUrl"
                ></uploadImgs>
                <el-image
                  v-else
                  :src="detailData.bsnsLicensepicUrl"
                  :preview-src-list="[
                    detailData.bsnsLicensepicUrl,
                    detailData.legalPersonpic1Url,
                    detailData.legalPersonpic2Url,
                  ]"
                ></el-image>
                <h6><span class="red">*</span>营业执照</h6>
              </div>
              <div class="imgBox">
                <uploadImgs :imgList.sync="imgLXRZ"></uploadImgs>
                <h6>联系人身份证正面</h6>
              </div>
              <div class="imgBox">
                <uploadImgs :imgList.sync="imgLXRF"></uploadImgs>
                <h6>联系人身份证背面</h6>
              </div>
              <div class="imgBox">
                <uploadImgs
                  :imgList.sync="imgFRZ"
                  v-if="!detailData.legalPersonpic1Url"
                ></uploadImgs>
                <el-image
                  v-else
                  :src="detailData.legalPersonpic1Url"
                  :preview-src-list="[
                    detailData.legalPersonpic1Url,
                    detailData.legalPersonpic2Url,
                    detailData.bsnsLicensepicUrl,
                  ]"
                ></el-image>
                <h6>法人身份证正面</h6>
              </div>
              <div class="imgBox">
                <uploadImgs
                  :imgList.sync="imgFRF"
                  v-if="!detailData.legalPersonpic2Url"
                ></uploadImgs>
                <el-image
                  v-else
                  :src="detailData.legalPersonpic2Url"
                  :preview-src-list="[
                    detailData.legalPersonpic2Url,
                    detailData.bsnsLicensepicUrl,
                    detailData.legalPersonpic1Url,
                  ]"
                ></el-image>
                <h6>法人身份证背面</h6>
              </div>
              <!-- <div class="imgBox">
                    <uploadImgs :imgList.sync='imgQY'  ></uploadImgs>
                    <h6>企业授权书</h6>
                </div> -->
            </div>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="KTDialog = false">取 消</el-button>
        <el-button type="primary" @click="KTsaveFn('KTfrom')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog
      title="详情"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="detail"
      :visible.sync="dialogDetail"
      width="1000px"
      center
    >
      <span>
        <el-form
          :inline="true"
          :model="addFrom"
          ref="addFrom"
          class="demo-form-inline"
          label-width="110px"
          size="mini"
        >
          <div class="inpBox">
            <div>
              <el-form-item label="客户名称:" prop="name" style="width: 320px">
                <div class="detailCont" style="width: 250px">
                  {{ addFrom.name }}
                </div>
              </el-form-item>
              <el-form-item label="客户类型:" prop="classify">
                <div class="detailCont">
                  {{ ['正式', '个体', '临时'][addFrom.classify - 1] }}
                </div>
              </el-form-item>
              <el-form-item
                label="统一社会信用代码:"
                prop="taxpayerNumber"
                v-if="addFrom.classify == 1"
                label-width="150px"
                style="width: 300px"
              >
                <div class="detailCont" style="width: 220px">
                  {{ addFrom.taxpayerNumber }}
                </div>
              </el-form-item>
              <el-form-item label="机构性质:" prop="nature">
                <div class="detailCont" style="width: 220px">
                  {{ addFrom.natureName }}
                </div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="经营业务:" prop="nature">
                <div class="detailCont">{{ addFrom.businessName }}</div>
              </el-form-item>
            </div>

            <div>
              <el-form-item
                label="企业地址:"
                prop="detailAddress"
                class="dizhi"
              >
                <div class="" style="width: 460px">
                  {{ addFrom.detailAddress }}
                </div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="开户行:" prop="openingBank">
                <div class="detailCont">{{ addFrom.openingBank }}</div>
              </el-form-item>
              <el-form-item label="银行账号:" prop="bankAccount">
                <div class="detailCont" style="width: 220px">
                  {{ addFrom.bankAccount }}
                </div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="联系人:" prop="contactsName">
                <div class="detailCont">{{ addFrom.contactsName }}</div>
              </el-form-item>
              <el-form-item label="联系电话:" prop="contactsMoblie">
                <div class="detailCont">{{ addFrom.contactsMoblie }}</div>
              </el-form-item>
              <el-form-item label="邮箱地址:" prop="email" v-if="isPingtai">
                <div class="detailCont">{{ addFrom.email }}</div>
              </el-form-item>
            </div>
            <div v-if="isPingtai">
              <div>
                <el-form-item label="企业类型:" prop="enterpriseType">
                  <div class="detailCont">
                    {{ ['一般人', '小规模'][addFrom.enterpriseType] }}
                  </div>
                </el-form-item>
                <el-form-item label="主管税务机关:" prop="taxCompetent">
                  <div class="detailCont">{{ addFrom.taxCompetent }}</div>
                </el-form-item>
                <el-form-item
                  label="注册资本:"
                  prop="registeredCapital"
                  class="jiage"
                >
                  <div class="detailCont">
                    {{ addFrom.registeredCapital }}万元
                  </div>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="经营范围:" prop="businessScope">
                  <div class="" style="width: 460px">
                    {{ addFrom.businessScope }}
                  </div>
                </el-form-item>
              </div>
            </div>
            <div>
              <el-form-item label="备注信息:" prop="remark">
                <div class="" style="width: 460px">{{ addFrom.remark }}</div>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogDetail = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 关联租户 -->
    <el-dialog
      title="关联租户"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="detail"
      :visible.sync="ZHdialog"
      width="1000px"
      center
    >
      <span>
        <el-table
          :data="zuhuList"
          bordersize="mini"
          style="width: 100%"
          height="400"
          center
          border
        >
          <el-table-column
            type="index"
            prop="date"
            width="55"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="name"
            width="200"
            :formatter="emptyFn"
            label="租户名称"
          ></el-table-column>
          <el-table-column
            prop="businessName"
            min-width="200"
            :formatter="emptyFn"
            label="经营业务"
          ></el-table-column>
          <el-table-column
            prop="taxpayerNumber"
            width="200"
            :formatter="emptyFn"
            label="统一社会信用代码"
          ></el-table-column>
          <el-table-column
            prop="natureName"
            width="200"
            :formatter="emptyFn"
            label="机构性质"
          ></el-table-column>
          <el-table-column property="type" label="租户类型" min-width="100">
            <template scope="scope">
              <div>
                {{ ['平台型', '租户'][scope.row.type] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            property="openTenantFlag"
            label="开通租户"
            min-width="100"
          >
            <template scope="scope">
              <div>
                {{ ['否', '是'][scope.row.openTenantFlag] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="createUserName"
            :formatter="emptyFn"
            label="开通人"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            width="170"
            :formatter="dateTimeFormat"
            label="开通时间"
          ></el-table-column>
        </el-table>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ZHdialog = false">关闭</el-button>
      </span>
    </el-dialog>
    <!--开通短信-->
    <el-dialog
      title="提示"
      :visible.sync="msgMark"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      center
    >
      <el-form
        :inline="true"
        :model="msgForm"
        ref="msgForm"
        :rules="rules"
        class="demo-form-inline jiaoyan"
        label-width="180px"
        size="mini"
      >
        <div class="inpBox">
          <div style="margin: 28px 0">
            <el-form-item label="企业名称:" style="width: 490px">
              <span>{{ msgForm.tenantName }}</span>
            </el-form-item>
            <el-form-item label="访问地址:" style="width: 490px">
              <span>{{ msgForm.address }}</span>
            </el-form-item>
            <el-form-item label="用户姓名:" style="width: 360px">
              <span>{{ msgForm.userName }}</span>
            </el-form-item>
            <el-form-item label="登录账号:" style="width: 360px">
              <span>{{ msgForm.userAccount }}</span>
            </el-form-item>
            <el-form-item label="登录密码:" style="width: 360px">
              <span>{{ msgForm.password }}</span>
            </el-form-item>
            <el-form-item
              label="以上信息是否短信告知:"
              prop="isSend"
              style="width: 360px"
            >
              <el-radio v-model="msgForm.isSend" label="0">是</el-radio>
              <el-radio v-model="msgForm.isSend" label="1">否</el-radio>
            </el-form-item>
            <el-form-item
              label="手机号:"
              prop="mobile"
              v-if="msgForm.isSend == 0"
              style="width: 360px"
            >
              <el-input
                placeholder=""
                v-number-input.float="0"
                maxlength="11"
                v-model.trim="msgForm.mobile"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="msgMark = false">取消</el-button>
        <el-button type="primary" @click="msgSave()">确定</el-button>
      </span>
    </el-dialog>
    <!-- 个性化配置 -->
    <gexinghua :row-data="row" @destroy="destroy" v-if="GXHdialog"></gexinghua>
    <!-- 选择地址 -->
    <mapAddressT
      :addFrom="addFrom"
      v-if="dizhiMark"
      @getAddress="getAddress"
      @destroy="destroy"
    ></mapAddressT>
    <!-- 导入 -->
    <importC v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
    <el-dialog
      title="授权记录"
      :close-on-click-modal="false"
      class="detailBox"
      :close-on-press-escape="false"
      :visible.sync="dialogDetailAR"
      @close="closeAR"
      center
    >
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          type="index"
          prop="date"
          width="55"
          label="序号"
        ></el-table-column>
        <el-table-column prop="date" label="授权状态"> </el-table-column>
        <el-table-column prop="name" label="授权人"> </el-table-column>
        <el-table-column prop="address" width="180" label="授权手机号">
        </el-table-column>
        <el-table-column prop="date" label="授权书"> </el-table-column>
        <el-table-column prop="date" label="授权截至日期" width="120">
        </el-table-column>
        <el-table-column prop="date" label="取消授权人" width="120">
        </el-table-column>
        <el-table-column prop="date" label="取消授权日期" width="180">
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="dialogDetailAR = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 客户等级弹窗 -->
    <el-dialog
      title="客户等级"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="gradeModalVisible"
      width="30%"
      class="customerGrade"
    >
      <div style="margin-bottom: 10px;">
        <el-button type="primary" @click="addCustomerGradeClick"
          >添加客户等级
        </el-button>
      </div>

      <el-table :data="gradeList" style="width: 100%" center border>
        <el-table-column label="序号" type="index" width="80px">
        </el-table-column>
        <el-table-column prop="name" label="操作">
          <template scope="scope">
            <el-button type="text" @click="editCustomerGradeClick(scope)"
              >编辑
            </el-button>
            <!-- <el-button type="text" @click="previewCustomerGradeClick">
              预览
            </el-button> -->
            <el-button
              v-if="
                scope.row.gradeName !== '普通会员' &&
                  scope.row.gradeName !== '内部人员'
              "
              type="text"
              @click="deleteCustomerGradeClick(scope)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="gradeName" label="等级名称"> </el-table-column>
      </el-table>
      <!-- 新增分页组件 -->
      <div style="text-align: right; margin-top: 10px;">
        <el-pagination
          background
          @size-change="handleGradeSizeChange"
          @current-change="handleGradeCurrentChange"
          :current-page="gradePageNo"
          :page-sizes="[5, 10, 30, 50]"
          :page-size="gradePageSize"
          layout=" sizes, prev, pager, next"
          :total="gradeTotal"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 添加客户等级弹窗 -->
    <el-dialog
      :title="addCustomerTitle"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :visible.sync="addGradeModalVisible"
      @close="addCustomerClose"
      width="1000px"
      class="customerGrade"
    >
    <div  style="margin-left: 12px;">
      <el-form
        :inline="true"
        class="demo-form-inline"
        label-width="140px"
        size="mini"
        label-position="top"
      >
        <div>
          <el-form-item label="等级名称:">
            <el-input
              style="width: 200px; "
              v-model="gradeForm.gradeName"
              placeholder="请输入客户等级名称"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>

      <div
        style="display: flex; justify-content: space-between; padding-right: 40px;"
      >
        <div style="width: 300px;">
          <div style="margin-left: 10px;">底图：</div>
          <ImageUploader :imgList.sync="ditu"></ImageUploader>
        </div>
        <div style="width: 300px;">
          <div style="margin-left: 10px;">VIP图片：</div>
          <ImageUploader :imgList.sync="viptupian"></ImageUploader>
        </div>
        <div style="width: 300px;">
          <div style="margin-left: 10px;">VIP头像：</div>
          <ImageUploader :imgList.sync="viptouxiang"></ImageUploader>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addCustomerClose">取 消</el-button>
        <el-button type="primary" @click="saveGrade">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑客户等级"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :visible.sync="editGradeModalVisible"
      width="1000px"
    >
      <div style="margin-left: 12px;">
        <el-form
          :inline="true"
          class="demo-form-inline"
          label-width="140px"
          size="mini"
          label-position="top"
        >
          <el-form-item label="等级名称:">
            <el-input
              style="width: 200px; "
              v-model="gradeForm1.gradeName"
              placeholder="请输入客户等级名称"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        style="display: flex; justify-content: space-between; padding-right: 40px;"
      >
        <div style="width: 300px;">
          <div style="margin-left: 10px;">底图：</div>
          <ImageUploader :imgList.sync="ditu1"></ImageUploader>
        </div>
        <div style="width: 300px;">
          <div style="margin-left: 10px;">VIP图片：</div>
          <ImageUploader :imgList.sync="viptupian1"></ImageUploader>
        </div>
        <div style="width: 300px;">
          <div style="margin-left: 10px;">VIP头像：</div>
          <ImageUploader :imgList.sync="viptouxiang1"></ImageUploader>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editCustomerClose">取 消</el-button>
        <el-button type="primary" @click="editSaveGrade">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addCustomer,
  addTenant,
  businessTree,
  deleteCustomer,
  detailCustomer,
  detailTenant,
  impCustomerExcel,
  sCompanyDetail,
  sCrmDictionaryList,
  sCustomerList,
  selectTenantListByCustId,
  sendMessage,
  updateCustomer,
  customerGradeList,
  addCustomerGrade,
  deleteCustomerGrade,
  updateCustomerGrade,
  getdeleteFlag
} from '@/api/newCrm'
import mapAddressT from '@/components/common/mapAddressT.vue'
import importC from '@/components/import.vue'
import uploadImgs from '@/components/uploadImgs.vue'
import { compressImages, compressImagesFn } from '@/utils/compressImages'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { getBtn } from '@/utils/getButton'
import { arrChaJi, dateFormat, dateTimeFormat, emptyFn } from '@/utils/util'
import business from '@/views/newCrm/components/business.vue'
import gexinghua from '@/views/newCrm/components/gexinghua.vue'
import ImageUploader from '@/components/ImageUploader.vue'

export default {
  props: {
    ZtenantCode: {
      // 租户管理跳过来
      type: String,
      default: null
    }
  },
  components: {
    uploadImgs,
    mapAddressT,
    business,
    importC,
    gexinghua,
    ImageUploader
  },
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      title: '新建',
      dialogVisible: false,
      dialogDetail: false,
      zuhuList: [],
      jigouList: [],
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      // 认证状态字典
      authStatusDic: {
        0: '未实名',
        1: '认证中',
        2: '认证完成'
      },
      // 授权状态字典
      sealAuthStatusDic: {
        0: '未授权',
        1: '授权中',
        2: '授权完成'
      },
      total: 0,
      ids: [],
      loading: 'false',
      rules: {
        name: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        nature: [
          { required: true, message: '请选择机构性质', trigger: 'blur' }
        ],
        taxpayerNumber: [
          {
            required: true,
            message: '请输入统一社会信用代码',
            trigger: 'blur'
          }
        ],
        customerGradeId: [
          { required: true, message: '请选择等级会员', trigger: 'blur' }
        ],
        detailAddress: [
          { required: true, message: '请选择企业地址', trigger: 'blur' }
        ],
        contactsName: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactsMoblie: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          this.rule.mobile
        ],
        email: [
          // { pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/, message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        legalPerson: [
          { required: true, message: '请输入法人姓名', trigger: 'blur' }
        ],
        legalIdentityCard: [
          { required: true, message: '请输入法人身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        legalIsLong: [
          { required: true, message: '请选择身份证是否长期', trigger: 'blur' }
        ],
        legalPersonidValidity: [
          { required: true, message: '请选择身份证有效期', trigger: 'blur' }
        ],
        classify: [
          { required: true, message: '请选择客户类型', trigger: 'blur' }
        ],
        contactsIdentityCard: [
          { required: true, message: '请输入联系人身份证号', trigger: 'blur' }
        ]
      },
      KTrules: {
        contactsIdentityCard: [
          { required: true, message: '请输入联系人身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        // legalPerson: [
        //   { required: true, message: '请输入法人姓名', trigger: 'blur' }
        // ],
        // legalIdentityCard: [
        //   { required: true, message: '请输入法人身份证号', trigger: 'blur' },
        //   { validator: this.rule.idCardValidity, trigger: 'blur' }
        // ],
        // legalIsLong: [
        //   { required: true, message: '请选择身份证是否长期', trigger: 'blur' }
        // ],
        // legalPersonidValidity: [
        //   { required: true, message: '请选择身份证有效期', trigger: 'blur' }
        // ],
        contactsName: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactsMoblie: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ]
      },
      addFrom: {},
      dizhiMark: false, // 地址
      isDisable: false, // 导出
      importDialog: false, // 导入
      oldBusinessIds: [],
      KTDialog: false, // 开通
      KTfrom: {},
      detailData: {},
      imgYY: [],
      imgFRZ: [],
      imgFRF: [],
      imgQY: [],
      imgLXRZ: [],
      imgLXRF: [],
      yewuTree: [],
      isAdd: false,
      ZHdialog: false,
      GXHdialog: false,
      msgMark: false,
      msgForm: {},
      isPingtai: false,
      row: {},
      btnFlg: [],
      btnIdArr: [
        '00d0040100',
        '00d0040200',
        '00d0040300',
        '00d0040400',
        '00d0040500',
        '00d0040600',
        '00d0040700',
        '00d0040800',
        '00d0040900',
        '00d0041000'
      ],
      dialogDetailAR: false,
      tableData: [],
      gradeModalVisible: false,
      addGradeModalVisible: false,
      addCustomerTitle: '',
      addCustomerType: 0,
      gradePageNo: 1,
      gradePageSize: 10,
      gradeTotal: 0, // 客户等级总数
      gradeList: [],
      ditu: [],
      viptupian: [],
      viptouxiang: [],
      gradeForm: {
        tenantCode: '',
        gradeName: '' // 等级名称及租户编码
      },
      editSaveId: null,
      editGradeModalVisible: false,
      ditu1: [],
      viptupian1: [],
      viptouxiang1: [],
      gradeForm1: {
        tenantCode: '',
        gradeName: '' // 等级名称及租户编码
      }
    }
  },
  created () {
    sCrmDictionaryList({ groupNo: 'tenant_type' }).then((res) => {
      this.jigouList = res
    })
    this.customerGradeListFn()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    if (this.ZtenantCode) {
      this.h = pH - h - 138 + 'px'
      this.isPingtai = false
      businessTree({ flag: 2, tenantCode: this.ZtenantCode }).then((res) => {
        this.yewuTree = this.getTreeData(res)
      })
    } else {
      this.h = pH - h - 98 + 'px'
      this.btnFlg = getBtn(this.btnIdArr)
      let userType = localStorage.getItem('userType')
      if (userType == 1) {
        this.isPingtai = true
      } else {
        this.isPingtai = false
      }
      if (this.isPingtai) {
        businessTree({ flag: 1 }).then((res) => {
          this.yewuTree = this.getTreeData(res)
        })
      } else {
        businessTree({
          flag: 2,
          tenantCode: localStorage.getItem('tenantCode')
        }).then((res) => {
          this.yewuTree = this.getTreeData(res)
        })
      }
    }
    this.getList(this.searchFrom)
    this.gradeForm.tenantCode = localStorage.getItem('tenantCode')
    this.gradeForm1.tenantCode = localStorage.getItem('tenantCode')
  },

  methods: {
    handleSuccess (file) {
      console.log('上传成功', file)
    },
    handleError (err) {
      console.error('上传失败', err)
    },
    // 个性化配置
    gexinghuaFn (row) {
      this.row = row
      if (!this.ZtenantCode) {
        let userType = localStorage.getItem('userType')
        let tenantCode = localStorage.getItem('tenantCode')
        if (userType == 1 && tenantCode == row.tenantCode) {
          this.row.tenantCodeH = row.code
        } else {
          this.row.tenantCodeH = row.tenantCode
        }
      } else {
        this.row.tenantCodeH = row.tenantCode
      }
      this.GXHdialog = true
    },
    // 客户名称失去焦点
    nameBlur () {
      if (this.addFrom.name) {
        sCompanyDetail({ name: this.addFrom.name }).then((res) => {
          if (res) {
            this.$set(this.detailData, 'name', res.name)
            this.$set(this.detailData, 'taxpayerNumber', res.taxpayerNumber)
            this.$set(this.detailData, 'classify', res.classify)
            this.$set(this.detailData, 'nature', res.nature)
            this.$set(
              this.detailData,
              'detailAddress',
              res.provinceName + res.cityName + res.areaName + res.address
            )
            this.addFrom = res
            this.addFrom.businessIdList = []
            this.$refs.business.businessNameList = []
            this.$set(
              this.addFrom,
              'detailAddress',
              res.provinceName + res.cityName + res.areaName + res.address
            )
            if (this.ZtenantCode) {
              this.addFrom.tenantCode = this.ZtenantCode
            } else {
              this.addFrom.tenantCode = localStorage.getItem('tenantCode')
            }
          }
        })
      }
    },
    // 递归判断列表，把最后的children设为undefined
    getTreeData (data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children)
        }
      }
      return data
    },
    // 开通
    kaitongFn (row) {
      this.KTDialog = true
      this.row = row
      detailTenant({ name: row.name }).then((res) => {
        this.$set(this.detailData, 'legalPerson', res.legalPerson)
        this.$set(this.detailData, 'legalIdentityCard', res.legalIdentityCard)
        this.$set(this.detailData, 'legalIsLong', res.legalIsLong)
        this.$set(
          this.detailData,
          'legalPersonidValidity',
          res.legalPersonidValidity
        )
        this.$set(this.detailData, 'legalPersonpic1Url', res.legalPersonpic1Url)
        this.$set(this.detailData, 'bsnsLicensepicUrl', res.bsnsLicensepicUrl)
        this.$set(this.detailData, 'legalPersonpic2Url', res.legalPersonpic2Url)
        this.KTfrom = { ...res }
        this.KTfrom.customerId = row.customerId
        this.KTfrom.companyId = row.companyId
        this.KTfrom.type = 1
        this.KTfrom.name = row.name
        this.KTfrom.taxpayerNumber = row.taxpayerNumber
        this.KTfrom.contactsMoblie = row.contactsMoblie
        this.KTfrom.contactsName = row.contactsName
        this.KTfrom.nature = row.nature
        this.KTfrom.relId = row.rId
        this.KTfrom.businessIdList = []
        this.$refs.business.businessNameList = []
        if (this.ZtenantCode) {
          this.KTfrom.tenantCode = this.ZtenantCode
        } else {
          this.KTfrom.tenantCode = localStorage.getItem('tenantCode')
        }
        // let userType = localStorage.getItem('userType')//是否为平台测试通过之后删除
        // let tenantCode = localStorage.getItem('tenantCode')
        // if (userType == 1 && tenantCode == row.tenantCode) {
        //   this.isPingtai = true
        // } else {
        //   this.isPingtai = false
        // }
      })
    },
    KTsaveFn () {
      if (this.KTfrom.businessIdList.length == 0) {
        this.$alert('请选择业务类型', '系统提示')
        return
      }
      this.$refs.KTfrom.validate((valid) => {
        if (valid) {
          let imgfile = new FormData()
          let imgList = []
          if (this.imgYY.length > 0) {
            imgList[0] = this.imgYY[0]
          } else if (this.detailData.bsnsLicensepicUrl) {
            imgList[0] = null
          } else {
            this.$alert('请完善证件信息', '系统提示')
            return
          }
          if (this.imgFRZ.length > 0) {
            imgList[1] = this.imgFRZ[0]
          } else if (this.detailData.legalPersonpic1Url) {
            imgList[1] = null
          }
          // else {
          //   this.$alert('请完善证件信息', '系统提示')
          //   return
          // }
          if (this.imgFRF.length > 0) {
            imgList[2] = this.imgFRF[0]
          } else if (this.detailData.legalPersonpic2Url) {
            imgList[2] = null
          }
          // else {
          //   this.$alert('请完善证件信息', '系统提示')
          //   return
          // }
          if (this.imgLXRZ.length > 0) {
            imgList[3] = this.imgLXRZ[0]
          }

          if (this.imgLXRF.length > 0) {
            imgList[4] = this.imgLXRF[0]
          }

          compressImages(imgList, {
            width: 1000
          }).then((result) => {
            if (result[0]) {
              imgfile.set('bsnsLicensepic', result[0])
            }
            if (result[1]) {
              imgfile.set('legalPersonpic1', result[1])
            }
            if (result[2]) {
              imgfile.set('legalPersonpic2', result[2])
            }
            if (result[3]) {
              imgfile.set('contactsPersonpic1', result[1])
            }
            if (result[4]) {
              imgfile.set('contactsPersonpic2', result[2])
            }

            this.KTfrom.sourceType = 2
            imgfile.set('params', JSON.stringify(this.KTfrom))
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            addTenant(imgfile)
              .then((res) => {
                loading.close()
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.KTDialog = false
                this.getList(this.searchFrom)
                let userType = localStorage.getItem('userType')
                let tenantCode = localStorage.getItem('tenantCode')
                if (userType == 1 && tenantCode == this.addFrom.tenantCode) {
                  this.msgMark = true
                  this.msgForm = res
                  this.$set(this.msgForm, 'isSend', '1')
                }
              })
              .catch((error) => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
          })
        } else {
          return false
        }
      })
    },
    msgSave () {
      if (this.msgForm.isSend == 0) {
        this.$refs.msgForm.validate((valid) => {
          if (valid) {
            sendMessage(this.msgForm)
              .then((res) => {
                this.$message({
                  message: '发送成功',
                  type: 'success'
                })
                this.msgMark = false
              })
              .catch((error) => {
                this.$message({
                  message: error.message,
                  type: 'error'
                })
              })
          }
        })
      } else {
        this.msgMark = false
      }
    },
    // 关联租户
    zuhuFn (row) {
      selectTenantListByCustId({ id: row.id }).then((res) => {
        this.zuhuList = res
        this.ZHdialog = true
      })
    },
    // 维护
    weihuFn (row) {
      if (this.btnFlg[8]) {
        row.menuOrBtnId = this.btnFlg[8]
      }
      this.$router.push({ name: 'customerMaintain', query: row })
    },
    // 客户类型切换
    classifyChange () {
      if (this.addFrom.classify == 3) {
        this.$set(this.addFrom, 'taxpayerNumber', '')
      }
    },
    // 添加
    addFn () {
      this.title = '添加客户'
      this.dialogVisible = true
      this.isAdd = true
      this.addFrom = {}
      this.detailData = {}
      if (this.ZtenantCode) {
        this.addFrom.tenantCode = this.ZtenantCode
      } else {
        this.addFrom.tenantCode = localStorage.getItem('tenantCode')
      }
    },

    // 修改
    editFn (row) {
      this.title = '修改'
      let arr = row.businessIds.split(',')
      this.oldBusinessIds = []
      arr.forEach((item) => {
        this.oldBusinessIds.push(Number(item))
      })
      this.$set(this.detailData, 'name', row.name)
      this.$set(this.detailData, 'taxpayerNumber', row.taxpayerNumber)
      this.$set(this.detailData, 'classify', row.classify)
      this.$set(this.detailData, 'nature', row.nature)
      this.$set(
        this.detailData,
        'detailAddress',
        row.provinceName + row.cityName + row.areaName + row.address
      )
      this.addFrom = { ...row }
      this.$set(
        this.addFrom,
        'detailAddress',
        row.provinceName + row.cityName + row.areaName + row.address
      )
      this.dialogVisible = true
      this.isAdd = false
      if (this.ZtenantCode) {
        this.addFrom.tenantCode = this.ZtenantCode
      } else {
        this.addFrom.tenantCode = localStorage.getItem('tenantCode')
      }
    },
    saveFn (formName) {
      console.log()
      if (this.addFrom.businessIdList.length == 0) {
        this.$alert('请选择业务类型', '系统提示')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            addCustomer(this.addFrom)
              .then((res) => {
                loading.close()
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.dialogVisible = false
                this.getList(this.searchFrom)
              })
              .catch((error) => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
          } else {
            let newBusinessIdList = [...this.addFrom.businessIdList]
            this.addFrom.delBusinessIdList = arrChaJi(
              this.oldBusinessIds,
              newBusinessIdList,
              1
            )
            this.addFrom.businessIdList = arrChaJi(
              this.oldBusinessIds,
              newBusinessIdList,
              2
            )

            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            updateCustomer(this.addFrom)
              .then((res) => {
                loading.close()
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                this.dialogVisible = false
                this.getList(this.searchFrom)
              })
              .catch((error) => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  duration: 0,
                  onClose () {
                    loading.close()
                  }
                })
              })
          }
        } else {
          return false
        }
      })
    },
    // 地址
    dizhiFn () {
      this.dizhiMark = true
    },
    getAddress (data) {
      this.dizhiMark = false
      for (let key in data) {
        this.addFrom[key] = data[key]
      }
    },
    // 详情
    detailFn (row) {
      detailCustomer({ rId: row.rId }).then((res) => {
        this.addFrom = { ...row }
        this.$set(
          this.addFrom,
          'detailAddress',
          row.provinceName + row.cityName + row.areaName + row.address
        )
        this.dialogDetail = true
      })
    },

    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) {
        this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(
          /[(\r\n)\r\n]+/
        )
      }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {},
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      if (this.ZtenantCode) {
        this.searchFrom.tenantCode = this.ZtenantCode
      } else {
        this.searchFrom.tenantCode = localStorage.getItem('tenantCode')
      }
      sCustomerList(this.searchFrom).then((res) => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          let code = ''
          if (this.ZtenantCode) {
            code = this.ZtenantCode
          } else {
            code = localStorage.getItem('tenantCode')
          }
          deleteCustomer({ rId: row.rId, tenantCode: code })
            .then((res) => {
              loading.close()
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getList()
            })
            .catch((error) => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        })
        .catch(() => {})
    },
    // 导出
    exportFn () {
      let form = this.searchFrom
      exportExcel(
        this.global.crmServer3 + '/sCustomer/exportCustomerList',
        form,
        '客户列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 导入
    importFn () {
      this.importDialog = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location =
        'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/template/crm/CRM3.0%E5%AE%A2%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx' // 后更改页面地址
    },
    DRsave (formData) {
      formData.append('MultipartFile', 'excl')
      let code = this.ZtenantCode
        ? this.ZtenantCode
        : localStorage.getItem('tenantCode')
      formData.append('tenantCode', code)
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      impCustomerExcel(formData)
        .then((res) => {
          loading.close()
          this.importDialog = false
          var that = this
          that.getList(that.searchFrom)
          this.msg = this.$message({
            showClose: true,
            message: res,
            duration: 0,
            type: 'success',
            onClose () {}
          })
        })
        .catch((error) => {
          this.msg = this.$message({
            showClose: true,
            message: error.message,
            duration: 0,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
    },
    destroy () {
      this.importDialog = false
      this.shipUnloadFlag = false
      this.GXHdialog = false
      this.dizhiMark = false
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog () {
      this.addFrom = {}
      this.detailData = {}
      this.imgYY = []
      this.imgFRZ = []
      this.imgFRF = []

      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
    },
    // 授权记录查看
    lookAR () {
      this.dialogDetailAR = true
    },
    // 授权记录取消关闭
    closeAR () {
      this.dialogDetailAR = false
    },
    // 客户等级
    customerGrade () {
      this.gradeModalVisible = true
      this.customerGradeListFn()
    },
    // 获取等级列表
    customerGradeListFn () {
      const params = {
        tenantCode: localStorage.getItem('tenantCode'),
        pageNo: this.gradePageNo, // 传递当前页
        pageSize: this.gradePageSize // 传递每页条数
      }
      customerGradeList(params).then((res) => {
        if (res) {
          // 1. 分离出需要置顶的项和普通项
          const priorityItems = []
          const normalItems = []

          res.list.forEach((item) => {
            if (
              item.gradeName === '普通会员' ||
              item.gradeName === '内部人员'
            ) {
              priorityItems.push(item)
            } else {
              normalItems.push(item)
            }
          })

          // 2. 对置顶项进行排序（普通会员在前，内部人员在后）
          priorityItems.sort((a, b) => {
            if (a.gradeName === '普通会员') return -1
            if (b.gradeName === '普通会员') return 1
            return 0
          })

          // 3. 合并数组（置顶项在前，普通项在后）
          this.gradeList = [...priorityItems, ...normalItems]
          this.gradeTotal = res.total // 赋值总条数
          this.addGradeModalVisible = false
          this.editGradeModalVisible = false
        }
      })
    },
    // 分页大小变更处理
    handleGradeSizeChange (val) {
      this.gradePageSize = val
      this.gradePageNo = 1 // 切换大小后重置为第一页
      this.customerGradeListFn()
    },

    // 页码变更处理
    handleGradeCurrentChange (val) {
      this.gradePageNo = val
      this.customerGradeListFn()
    },
    // 客户等级编辑
    editCustomerGradeClick (scope) {
      this.gradeForm1.id = scope.row.id
      this.gradeForm1.gradeName = scope.row.gradeName

      this.$set(this.ditu1, 0, {
        status: 'ready',
        url: scope.row.backgroundImgUrl,
        isEdit: true
      })
      this.$set(this.viptupian1, 0, {
        status: 'ready',
        url: scope.row.vipImgUrl,
        isEdit: true
      })
      this.$set(this.viptouxiang1, 0, {
        status: 'ready',
        url: scope.row.vipProfileImgUrl,
        isEdit: true
      })
      console.log(this.ditu1, 'this.ditu')

      // // 强制更新组件（触发重新渲染）
      this.$nextTick(() => {
        this.$forceUpdate()
      })
      this.editGradeModalVisible = true
    },
    // 预览客户等级
    previewCustomerGradeClick () {},
    // 删除客户等级
    deleteCustomerGradeClick (scope) {
      getdeleteFlag({ id: scope.row.id })
        .then((res) => {
          console.log(res)
          this.$confirm(
            '确认要删除该客户等级吗，删除后将不可恢复！',
            '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }
          )
            .then((res) => {
              const params = {
                tenantCode: localStorage.getItem('tenantCode'),
                id: scope.row.id
              }
              console.log(params, 'params')
              const loading = this.$loading({
                lock: true,
                text: '正在处理...'
              })
              deleteCustomerGrade(params)
                .then((res) => {
                  loading.close()
                  this.$message({
                    message: '成功',
                    type: 'success'
                  })
                  this.customerGradeListFn()
                })
                .catch((error) => {
                  this.$message({
                    showClose: true,
                    message: error.message,
                    type: 'error',
                    onClose () {
                      loading.close()
                    }
                  })
                })
            })
            .catch(() => {})
        })
        .catch((error) => {
          this.$message.error(error.message)
        })
    },
    // 添加客户等级
    addCustomerGradeClick () {
      delete this.gradeForm.id
      this.gradeForm.gradeName = ''
      this.ditu = []
      this.viptupian = []
      this.viptouxiang = []
      this.addCustomerTitle = '添加客户等级'
      this.addCustomerType = 0
      this.addGradeModalVisible = true
    },
    // 添加客户等级保存
    saveGrade () {
      // 1. 表单基础验证（等级名称必填）
      if (this.gradeForm.gradeName == '') {
        this.$message.error('请输入等级名称')
        return
      }
      let imgList = []
      let formData = new FormData()
      if (this.ditu.length == 0) {
        this.$alert('请上传营业执照', '系统提示')
        return
      }

      if (this.ditu.length > 0 && !this.ditu[0].isEdit) {
        imgList[0] = this.ditu[0]
        console.log('有00000')
      } else if (this.ditu.length > 0 && this.ditu[0].isEdit) {
        imgList[0] = null
        console.log('没有')
      }
      if (this.viptupian.length > 0 && !this.viptupian[0].isEdit) {
        imgList[1] = this.viptupian[0]
      } else if (this.viptupian.length > 0 && this.viptupian[0].isEdit) {
        imgList[1] = null
      }
      if (this.viptouxiang.length > 0 && !this.viptouxiang[0].isEdit) {
        imgList[2] = this.viptouxiang[0]
      } else if (this.viptouxiang.length > 0 && this.viptouxiang[0].isEdit) {
        imgList[2] = null
      }
      console.log(imgList, 'imgList')

      formData.set('params', JSON.stringify(this.gradeForm)) // 等级名称
      compressImages(imgList, {
        width: 1000
      }).then((result) => {
        if (result[0]) {
          formData.set('backgroundImgFile', result[0])
        }
        if (result[1]) {
          formData.set('vipImgFile', result[1])
        }
        if (result[2]) {
          formData.set('vipProfileImgFile', result[2])
        }

        formData.set('params', JSON.stringify(this.gradeForm)) // 等级名称
        const loading = this.$loading({ lock: true, text: '保存中...' })
        addCustomerGrade(formData) // 假设接口接受FormData
          .then((res) => {
            loading.close()
            this.$message.success('客户等级添加成功')
            this.gradeForm.gradeName = ''
            this.ditu = []
            this.viptupian = []
            this.viptouxiang = []
            this.customerGradeListFn()
          })
          .catch((error) => {
            loading.close()
            this.$message.error(`保存失败：${error.message}`)
          })
      })
    },

    editSaveGrade () {
      // 1. 表单基础验证（等级名称必填）
      if (this.gradeForm1.gradeName == '') {
        this.$message.error('请输入等级名称')
        return
      }
      let imgList = []
      let formData = new FormData()
      if (this.ditu1.length == 0) {
        this.$alert('请上传底图', '系统提示')
        return
      }
      if (this.viptupian1.length == 0) {
        this.$alert('请上传VIP图片', '系统提示')
        return
      }
      if (this.viptouxiang1.length == 0) {
        this.$alert('请上传VIP头像', '系统提示')
        return
      }

      if (this.ditu1.length > 0 && !this.ditu1[0].isEdit) {
        imgList[0] = this.ditu1[0]
      } else if (this.ditu1.length > 0 && this.ditu1[0].isEdit) {
        imgList[0] = null
      }
      if (this.viptupian1.length > 0 && !this.viptupian1[0].isEdit) {
        imgList[1] = this.viptupian1[0]
      } else if (this.viptupian1.length > 0 && this.viptupian1[0].isEdit) {
        imgList[1] = null
      }
      if (this.viptouxiang1.length > 0 && !this.viptouxiang1[0].isEdit) {
        imgList[2] = this.viptouxiang1[0]
      } else if (this.viptouxiang1.length > 0 && this.viptouxiang1[0].isEdit) {
        imgList[2] = null
      }

      console.log(this.ditu1, imgList, 'imgList')
      compressImagesFn(imgList, {
        width: 1000
      }).then((result) => {
        console.log(result, 'result')

        if (result[0]) {
          formData.set('backgroundImgFile', result[0])
        }
        if (result[1]) {
          formData.set('vipImgFile', result[1])
        }
        if (result[2]) {
          formData.set('vipProfileImgFile', result[2])
        }

        formData.set('params', JSON.stringify(this.gradeForm1)) // 等级名称
        const loading = this.$loading({ lock: true, text: '保存中...' })
        updateCustomerGrade(formData) // 假设接口接受FormData
          .then((res) => {
            loading.close()
            this.$message.success('客户等级编辑成功')
            this.customerGradeListFn()
          })
          .catch((error) => {
            loading.close()
            this.$message.error(`保存失败：${error.message}`)
          })
      })
    },

    addCustomerClose () {
      this.addGradeModalVisible = false
    },
    editCustomerClose () {
      this.editGradeModalVisible = false
    }
  },
  destroyed () {
    if (this.msg) {
      this.msg.close()
    }
  }
}
</script>

<style scoped lang="less">
.dizhi {
  position: relative;
  .el-icon-location {
    position: absolute;
    right: -30px;
    top: 0;
    font-size: 25px;
    color: #0e6eec;
  }
  /deep/.el-input__inner {
    width: 440px !important;
  }
}
.searchBtnBox {
  margin-left: 10px;
  display: flex;
  justify-content: space-between;
}
.searchBox .el-date-editor {
  width: 350px !important;
}
.imgBox {
  display: flex;
  .item {
    display: flex;
    width: 50%;
    justify-content: space-around;
  }
}
/deep/.inpBox .el-input__inner {
  width: 180px;
}
/deep/ .checkboxBox {
  display: flex;
  label {
    flex-shrink: 0;
  }
  .el-checkbox-group {
    width: 250px;
  }
}
.detail /deep/.el-form-item__content {
  width: 150px;
}
.box {
  display: flex;
  flex-wrap: wrap;
  .imgBox {
    display: flex;
    margin-right: 30px;
    flex-direction: column;
    width: 320px;
    /deep/.el-upload--picture-card {
      width: 320px;
      height: 200px;
    }
    /deep/.el-image {
      height: 200px;
    }
  }
  h6 {
    text-align: center;
  }
  .hidden /deep/.el-upload--picture-card {
    display: none;
  }
  /deep/.el-upload--picture-card {
    background-image: url(../../../assets/images/upload1.png);
    background-size: 320px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 320px;
    height: 200px;
  }
}
.iconFont {
  color: #0e6eec;
}
.authStatus_0 {
  color: #db0b0b !important;
}
.authStatus_1 {
  color: #17e409 !important;
}
.authStatus_2 {
  color: #0e6eec !important;
}
.sealAuthStatus_0 {
  color: #db0b0b !important;
}
.sealAuthStatus_1 {
  color: #17e409 !important;
}
.sealAuthStatus_2 {
  color: #0e6eec !important;
}
/deep/.el-upload--picture-card {
  background-image: url(../../../assets/images/updateBg.png);
  background-size: 320px;
  width: 280px;
  height: 180px;

}
/deep/.el-upload-list--picture-card .el-upload-list__item{
  width: 280px;
  height: 180px;

}
/deep/.el-upload-dragger{
  background-color:transparent;
  width: 280px;
}
/deep/.customerGrade .el-dialog__header {
  background-color: rgba(245, 245, 245, 1);
  .el-dialog__title {
    color: #333;
    font-size: 16px;
  }

  .el-icon-close {
    color: #a09f9f;
  }
  .el-dialog__headerbtn:hover {
    color: #409eff;
  }
}
/deep/.jiaoyan{
  .el-dialog__header{
  background-color: rgba(245, 245, 245, 1);

  }
  .el-dialog__title {
    color: #333;
    font-size: 16px;
  }
  .el-dialog__headerbtn:hover {
    color: #409eff;
  }
  .el-icon {
    color: #a09f9f;
  }
}
</style>
